export const PROFILE_BANNER_IMAGE_SOURCE =
  'https://raw.githubusercontent.com/rango-exchange/assets/main/banners/widget/profile.jpg';
export const PROFILE_BANNER_NAVIGATION_LINK = '/profile';
